// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-card {
  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;
  padding: 15px;
  border-radius: 20px;
  margin: 20px;
}
.request-card .right-side {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-left: 20px;
  direction: rtl;
  text-align: right;
}
.request-card .right-side div {
  align-items: baseline;
  display: inline-flex;
}
.request-card .right-side div * {
  margin-right: 5px;
}
.request-card .left-side {
  flex: 1 1 100%;
  box-sizing: border-box;
  max-width: 25%;
  justify-content: center;
  display: flex;
  border-right: 4px dashed #eee;
}
.request-card .left-side div {
  display: inline-flex;
}
.request-card .left-side div * {
  margin-right: 5px;
}

.item {
  padding: 0 10px;
  margin-top: 17px;
  min-width: 230px;
  align-items: center;
  justify-content: center;
}

.text-item {
  font-size: 13px;
}

p {
  margin-top: 10px;
}

.btn_accept {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 150px;
  border: 2px solid #eee;
  margin-right: auto;
  margin-top: 15px;
  background-color: #2a8954;
  color: white;
}

.btn_reject {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 150px;
  border: 2px solid #eee;
  margin-right: auto;
  margin-top: 15px;
  background-color: #d92727;
  color: white;
}

.icon-card {
  margin: auto;
  margin-top: 1px;
  margin-left: 8px;
  font-size: 20px;
}

label {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/withdraw/withdraw-card/withdraw-card.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/withdraw/withdraw-card/withdraw-card.component.scss"],"names":[],"mappings":"AAAA;EACI,uGAAA;EAEA,aAAA;EACA,mBAAA;EACA,YAAA;ACAJ;ADCI;EAQE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;ACNN;ADPM;EACE,qBAAA;EACA,oBAAA;ACSR;ADRQ;EACE,iBAAA;ACUV;ADCI;EACE,cAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;ACCN;ADAM;EACE,oBAAA;ACER;ADDQ;EACE,iBAAA;ACGV;;ADEE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACCJ;;ADCE;EACE,eAAA;ACEJ;;ADCE;EACE,gBAAA;ACEJ;;ADAE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;ACGJ;;ADDE;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;ACIJ;;ADFE;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACKJ;;ADHE;EACE,eAAA;ACMJ","sourcesContent":[".request-card {\r\n    box-shadow: rgb(103 103 103 / 35%) -4px 0px 20px 2px,\r\n      rgb(255 255 255 / 40%) -20px -1px 60px -30px;\r\n    padding: 15px;\r\n    border-radius: 20px;\r\n    margin: 20px;\r\n    .right-side {\r\n      div {\r\n        align-items: baseline;\r\n        display: inline-flex;\r\n        * {\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex-wrap: wrap;\r\n      justify-content: space-between;\r\n      padding-left: 20px;\r\n      direction: rtl;\r\n      text-align: right;\r\n    }\r\n    .left-side {\r\n      flex: 1 1 100%;\r\n      box-sizing: border-box;\r\n      max-width: 25%;\r\n      justify-content: center;\r\n      display: flex;\r\n      border-right: 4px dashed #eee;\r\n      div {\r\n        display: inline-flex;\r\n        * {\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .item {\r\n    padding: 0 10px;\r\n    margin-top: 17px;\r\n    min-width: 230px;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .text-item{\r\n    font-size: 13px;\r\n  }\r\n  \r\n  p {\r\n    margin-top: 10px;\r\n  }\r\n  .btn_accept {\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 150px;\r\n    border: 2px solid #eee;\r\n    margin-right: auto;\r\n    margin-top: 15px;\r\n    background-color: #2a8954;\r\n    color: white;\r\n  }\r\n  .btn_reject{\r\n    border-radius: 15px;\r\n    height: 45px;\r\n    font-size: 12px;\r\n    width: 150px;\r\n    border: 2px solid #eee;\r\n    margin-right: auto;\r\n    margin-top: 15px;\r\n    background-color: #d92727;\r\n    color: white;\r\n  }\r\n  .icon-card {\r\n    margin: auto;\r\n    margin-top: 1px;\r\n    margin-left: 8px;\r\n    font-size: 20px;\r\n  }\r\n  label{\r\n    font-size: 12px;\r\n  }\r\n  ",".request-card {\n  box-shadow: rgba(103, 103, 103, 0.35) -4px 0px 20px 2px, rgba(255, 255, 255, 0.4) -20px -1px 60px -30px;\n  padding: 15px;\n  border-radius: 20px;\n  margin: 20px;\n}\n.request-card .right-side {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-left: 20px;\n  direction: rtl;\n  text-align: right;\n}\n.request-card .right-side div {\n  align-items: baseline;\n  display: inline-flex;\n}\n.request-card .right-side div * {\n  margin-right: 5px;\n}\n.request-card .left-side {\n  flex: 1 1 100%;\n  box-sizing: border-box;\n  max-width: 25%;\n  justify-content: center;\n  display: flex;\n  border-right: 4px dashed #eee;\n}\n.request-card .left-side div {\n  display: inline-flex;\n}\n.request-card .left-side div * {\n  margin-right: 5px;\n}\n\n.item {\n  padding: 0 10px;\n  margin-top: 17px;\n  min-width: 230px;\n  align-items: center;\n  justify-content: center;\n}\n\n.text-item {\n  font-size: 13px;\n}\n\np {\n  margin-top: 10px;\n}\n\n.btn_accept {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 150px;\n  border: 2px solid #eee;\n  margin-right: auto;\n  margin-top: 15px;\n  background-color: #2a8954;\n  color: white;\n}\n\n.btn_reject {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 150px;\n  border: 2px solid #eee;\n  margin-right: auto;\n  margin-top: 15px;\n  background-color: #d92727;\n  color: white;\n}\n\n.icon-card {\n  margin: auto;\n  margin-top: 1px;\n  margin-left: 8px;\n  font-size: 20px;\n}\n\nlabel {\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
